import { useRef, useState } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import {
  Tooltip,
  tooltipPlacement,
} from "@visiblethread/react-components/dist/components/Tooltip";

const Ellipsis = ({ text, tooltip, classes, style }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipStyles, setTooltipStyles] = useState({});
  const spanRef = useRef(null);

  const handleMouseOver = ({ target }) => {
    const parent = target.parentElement;
    const boundingClient = target.getBoundingClientRect();
    if (
      target.offsetWidth < target.scrollWidth ||
      parent.offsetWidth < parent.scrollWidth
    ) {
      setTooltipStyles({
        position: "fixed",
        top: `${boundingClient.y + boundingClient.height}px`,
        left: `${boundingClient.x + boundingClient.width / 2}px`,
      });
      setShowTooltip(true);
    } else {
      setShowTooltip(false);
    }
  };

  const handleMouseOut = () => {
    setShowTooltip(false);
  };

  return (
    <div className="ellipsis_text__wrapper">
      <span
        className={`ellipsis_text ${classes}`}
        style={style}
        ref={spanRef}
        data-testid="ellipsis"
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
      >
        {text}
        {showTooltip &&
          ReactDOM.createPortal(
            <Tooltip
              content={tooltip || text}
              placement={tooltipPlacement.bottom}
              style={tooltipStyles}
            />,
            document.body
          )}
      </span>
    </div>
  );
};

export default Ellipsis;

Ellipsis.propTypes = {
  text: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  classes: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
};
